import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../utils/rel';

class AddRed extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isIpad: PropTypes.bool,
        turnRed: PropTypes.bool,
        handleCloseTurnRed: PropTypes.func,
    };

    handleClick = () => {
        const { handleCloseTurnRed } = this.props;

        handleCloseTurnRed();
    };

    render() {
        const {
            content: { src, ipadSrc, url },
            isIpad,
            turnRed,
        } = this.props;

        const body = document.querySelector('body');

        if (turnRed) {
            body.style.backgroundColor = '#fff';
            body.style.backgroundImage = `url(${isIpad ? ipadSrc : src})`;
            body.style.backgroundPosition = 'center 1px';
            body.style.backgroundRepeat = 'no-repeat';
        } else {
            body.style.background = 'none';
        }

        return turnRed ? (
            <div className={styles.red_cog}>
                <div className={styles.top_img}>
                    <div className={styles.closed} onClick={this.handleClick} />
                    <a className={styles.a_link} href={url} target="_blank" rel={rel} />
                </div>
            </div>
        ) : (
            <div />
        );
    }
}

export default errorBoundary(AddRed);
